module.exports = __webpack_public_path__ + "img/1524534336.31070bcc.jpg";